import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "frame", "url", "code", "status", "apply", "reset"]
  static values = { updated: String, error: String }

  apply(event) {
    event.preventDefault()
    if (this.formTarget.reportValidity()) this.update(new FormData(this.formTarget))
  }

  reset(event) {
    event.preventDefault()
    this.update(new FormData())
  }

  async update(data) {
    if (this.applyTarget.disabled) return
    this.applyTarget.disabled = true
    this.resetTarget.setAttribute("aria-disabled", "true")
    try {
      const endpoint = new URL(this.formTarget.action)
      endpoint.search = new URLSearchParams(data).toString()
      const response = await fetch(endpoint, { headers: { Accept: "application/json" } })
      if (!response.ok) throw new Error("Preview request failed")
      const preview = await response.json()
      for (const [key, value] of Object.entries(preview.settings)) {
        this.formTarget.elements.namedItem(key).value = value
      }
      this.frameTarget.width = preview.settings.width
      this.frameTarget.height = preview.settings.height
      // Replace the child history entry too, so Back/Forward only visits pages.
      this.frameTarget.contentWindow.location.replace(preview.url)
      this.urlTarget.value = preview.url
      this.codeTarget.value = preview.code
      this.statusTarget.textContent = this.updatedValue
      history.replaceState(null, "", endpoint.pathname + endpoint.search)
    } catch {
      this.statusTarget.textContent = this.errorValue
    } finally {
      this.applyTarget.disabled = false
      this.resetTarget.removeAttribute("aria-disabled")
    }
  }
}
